// Product videos arrive as a Wistia hash, a Vimeo id or url, or a direct file
// url. A file url has no metadata service behind it, so callers that look up a
// thumbnail need to tell it apart rather than treat it as a Wistia hash. The
// order here matches how PDPProductIntroVideo picks a player.
const getVideoType = videoId => {
  if (!videoId || /vimeo\.com/i.test(videoId)) {
    return 'vimeo';
  }

  if (/^https?:\/\//i.test(videoId)) {
    return 'file';
  }

  if (/[a-z]/i.test(videoId)) {
    return 'wistia';
  }

  return 'vimeo';
};

export default getVideoType;
